// @flow
import { DestinosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    destino: {},
    listaDestinos: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type DestinosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { destino?: {} | null, listaDestinos?: [] | null, loading?: boolean, +value ?: boolean };

const Destinos = (state: State = INIT_STATE, action: DestinosAction): any => {
    // console.log(action);
    switch (action.type) {
        case DestinosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DestinosActionTypes.GET_DESTINO: {
                    return {
                        ...state,
                        destino: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }      
                case DestinosActionTypes.LIST_DESTINOS: {
                    return {
                        ...state,
                        listaDestinos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DestinosActionTypes.ADD_DESTINO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DestinosActionTypes.UPDATE_DESTINO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DestinosActionTypes.DELETE_DESTINO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DestinosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DestinosActionTypes.GET_DESTINO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        destino: {},
                        loading: false,
                    };
                }
                case DestinosActionTypes.LIST_DESTINOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaDestinos: [],
                        loading: false,
                    };
                }
                case DestinosActionTypes.ADD_DESTINO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DestinosActionTypes.UPDATE_DESTINO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DestinosActionTypes.DELETE_DESTINO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DestinosActionTypes.GET_DESTINO:
            return { ...state, error: false, loading: true };
        case DestinosActionTypes.LIST_DESTINOS:
            return { ...state, error: false, loading: true };
        case DestinosActionTypes.ADD_DESTINO:
            return { ...state, error: false, loading: true };
        case DestinosActionTypes.UPDATE_DESTINO:
            return { ...state, error: false, loading: true };
        case DestinosActionTypes.DELETE_DESTINO:
            return { ...state, error: false, loading: true };
        case DestinosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                destino: {},
                listaDestinos: [],
                formSubmited: false,
            };
        case DestinosActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Destinos;
